const React = require('react');
const getUrlParam = require('../../helper/dish-helper.js').getUrlParam;
const shallowCompare = require('react-addons-shallow-compare');
// eslint-disable-next-line
import { getPoiList } from '../../helper/map-TARGET_AREA';

import FormattedMessage from '@/intl/formatted-message';
import shopText from '../../intl/messages/shop';

import './receive-all.scss';

const shopId = getUrlParam('shopId');
const brandId = getUrlParam('brandId');

const receiveAll = React.createClass({
  displayName: 'receiveAll',
  propTypes: {
    mineAddressList: React.PropTypes.array,
    getMineAddressList: React.PropTypes.func.isRequired,
    setLoadMsg: React.PropTypes.func.isRequired,
    curPosition: React.PropTypes.object.isRequired,
    curAddressOk: React.PropTypes.bool.isRequired,
    getCurrentCity: React.PropTypes.func,
  },

  getInitialState() {
    return {
      showAllShop: false,
      initShowNum: 3,
      nearAddressList: [],
    };
  },

  componentDidMount() {
    const { getMineAddressList, setLoadMsg, getCurrentCity, curAddressOk, curPosition = {} } = this.props;

    if (curAddressOk) {
      getMineAddressList().then(this.getNearAddressList(curPosition)); // getAllAddressListAPI
      getCurrentCity(curPosition.city);
    } else {
      getMineAddressList().then(setLoadMsg({ status: false, word: false }));
    }
  },

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  },

  getNearAddressList(point) {
    getPoiList(point)
      .then(nearAddressList => {
        this.setState({ nearAddressList }, () => {
          this.setState({ nearAddress: this.setNearAddress() });
        });
      })
      .catch(error => {
        console.log(error);
      });
  },

  setShowAddress(e) {
    e.preventDefault();
    const { mineAddressList = [] } = this.props;

    this.setState({ initShowNum: mineAddressList.length });
  },

  setMineAddress() {
    const { initShowNum } = this.state;
    const { mineAddressList } = this.props;
    const length = mineAddressList.length;
    const hideRemain = '';

    const mineAddress = mineAddressList.map((item = {}, index) => {
      if (index > initShowNum - 1) {
        return false;
      }
      return (
        <div className="option" key={item.id} onTouchTap={e => this.jumpToList(e, item.address, item.longitude, item.latitude, item)}>
          <div className="option-person ellipsis">
            {item.name} {item.mobile}
          </div>
          <div className="option-address ellipsis">{item.address}</div>
        </div>
      );
    });

    const showClickButton = () => {
      if (length <= 3) {
        return false;
      } else if (length !== initShowNum) {
        return (
          <p className={`${hideRemain} receive-remain`} onTouchTap={this.setShowAddress}>
            <FormattedMessage {...shopText.shopremainAddress} values={{ num: length - initShowNum }} />
          </p>
        );
      }

      return (
        <p className={`${hideRemain} receive-remain`} onTouchTap={this.unfoldAddress}>
          <FormattedMessage {...shopText.shopcloseUpAddress} />
        </p>
      );
    };

    return (
      <div>
        {mineAddressList && mineAddressList.length > 0 && (
          <div>
            <h3 className="title">
              <i className="title-icon"></i>
              <FormattedMessage {...shopText.shopyourAddress} />
            </h3>
            <div className="options-group options-group-spe">{mineAddress}</div>
            {showClickButton(length, initShowNum)}
          </div>
        )}
      </div>
    );
  },

  setNearAddress() {
    const { setLoadMsg, curAddressOk } = this.props;
    const { nearAddressList } = this.state;

    let nearAddress = (nearAddressList || []).map((item, index) => (
      <div className="option" key={index} onTouchTap={e => this.jumpToList(e, `${item.title}：${item.address}`, item.longitude, item.latitude)}>
        <div className="option-person ellipsis">{item.title}</div>
        <div className="option-address ellipsis">{item.address}</div>
      </div>
    ));
    setLoadMsg({ status: false, word: false });
    if (nearAddressList && nearAddressList.length > 0) {
      nearAddress = <div className="options-group">{nearAddress}</div>;
    } else {
      nearAddress = (
        <p className="near-locate-fail">
          <FormattedMessage {...shopText.shopnotSearchAddress} />
        </p>
      );
    }

    return (
      <div>
        <h3 className="title">
          <FormattedMessage {...shopText.shopNearAddress} />
        </h3>
        {!curAddressOk ? (
          <p className="near-locate-fail">
            <FormattedMessage {...shopText.shoplocateFailed} />
          </p>
        ) : (
          nearAddress
        )}
      </div>
    );
  },

  unfoldAddress(e) {
    e.preventDefault();
    this.setState({ initShowNum: 3 });
  },

  jumpToList(e, address, lng, lat, obj) {
    e.preventDefault();
    window.chosenAddress = {
      brandId,
      uniqueId: 'WM',
      shopId,
      longitude: `${lng}`,
      latitude: `${lat}`,
      isGetLoc: true,
      address,
    };
    sessionStorage.removeItem('receiveOrderCustomerInfo');
    if (obj) {
      // 从我的地址选中的时候
      const receiveOrderCustomerInfo = {
        id: 'customer-info-selected-address',
        addresses: [
          {
            rangeId: 0,
            id: obj.id,
            customerID: obj.customerID,
            address: obj.address,
            street: obj.street,
            name: obj.name,
            sex: obj.sex,
            mobile: obj.mobile,
            longitude: obj.longitude,
            latitude: obj.latitude,
            baseAddress: obj.baseAddress,
            isChecked: true,
          },
        ],
      };

      sessionStorage.receiveOrderCustomerInfo = JSON.stringify(receiveOrderCustomerInfo);
    }
    location.hash = '';
  },

  render() {
    const mineAddress = this.setMineAddress();

    return (
      <div className="receive-all">
        {mineAddress}
        {this.state.nearAddress}
      </div>
    );
  },
});

module.exports = receiveAll;



// WEBPACK FOOTER //
// ./src/component/shop-list/receive-all.jsx